import { NamePrefixModifier } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import AsSamplePreparationSection from 'Components/Worksheets/Shared/AS/Preparation/PreparationSection';
import ids from '../../QestIds';
import AsLiquidLimitFourPointSectionWithShrinkage from './LiquidLimit/FourPoint/LiquidLimitFourPointSectionWithShrinkage';
import { AsPlasticLimitSection } from './PlasticLimit';
import LinearShrinkageSection from './Sections/LinearShrinkageSection';
import ResultsSectionWithShrinkage from './Sections/ResultsSectionWithShrinkage';

const qestIds = [ids.atterbergLimit.AS_1289_3_1_1or3_2_1or3_3_1or3_4_1.rev2009];

let AsAtterbergLimitWorksheetFourPointWithShrinkage: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Sample Preparation">
        <NamePrefixModifier appendNamePrefix="SamplePreparation">
          <AsSamplePreparationSection />
        </NamePrefixModifier>
      </PageSection>
      <PageSection heading="Liquid Limit (Four Point Casagrande)">
        <AsLiquidLimitFourPointSectionWithShrinkage />
      </PageSection>
      <AsPlasticLimitSection />
      <LinearShrinkageSection />
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <ResultsSectionWithShrinkage />
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

AsAtterbergLimitWorksheetFourPointWithShrinkage.qestIds = qestIds;

export default AsAtterbergLimitWorksheetFourPointWithShrinkage;
